import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-agent-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.css']
})
export class AgentSubHeaderComponent implements OnInit {
  @Input('title') title:string;

  constructor() { }

  ngOnInit() {
  }

}
